<template>
  <dl class="dl">
    <template v-for="(item, index) in data">
      <dt
        :key="'title' + index"
        class="dl__dt"
      >
        {{ item.title }}
      </dt>
      <dd
        :key="'desc' + index"
        class="dl__dd"
      >
        {{ item.desc }}
      </dd>
    </template>
  </dl>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        default: () => []
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .dl {
    display: flex;
    flex-flow: row wrap;
    text-align: left;
    vertical-align: top;
    &__dt,
    &__dd {
      padding-top: 2px;
      padding-bottom: 2px;
    }
    &__dt {
      flex-basis: 30%;
      max-width: 30%;
      font-weight: normal;
      padding-right: 1.5rem;
    }
    &__dd {
      font-weight: bold;
      flex: 1 1 70%;
      max-width: 70%;
      min-width: 0;
      margin-bottom: 0;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
  }
</style>
